var map = {
	"./car.svg": 3984,
	"./club.svg": 9721,
	"./education.svg": 8650,
	"./medical.svg": 4950,
	"./music.svg": 2537,
	"./none.svg": 1047,
	"./other.svg": 2954,
	"./pets.svg": 909,
	"./present.svg": 2257,
	"./shopping.svg": 3173,
	"./sport.svg": 2611,
	"./vacation.svg": 633,
	"./work.svg": 3467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6022;